import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.thirdStepAddDevice')))];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-arrow-left",
            "title": _vm.$i18n_t('Common.reset')
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('reset-originator');
            }
          }
        }), _vm.selectedItems.length && _vm.tabItem !== 'add-new-device' ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "disabled": _vm.selectedItems.length && !_vm.errors.length ? false : true
          },
          on: {
            "click": function ($event) {
              return _vm.addItem();
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.add')) + "\n        ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c(VRow, {
    staticClass: "n20-mainrow pb-4 mb-0 pb-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12 mb-0 pb-0"
    }
  }, [_c('core-n20Card', {
    staticClass: "mb-0 pb-0"
  }, [_c(VTabs, {
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _vm.createPossible ? _c(VTab, {
    staticClass: "text-caption",
    attrs: {
      "href": "#add-new-device"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-plus")]), !_vm.isMobile ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.createNewDevice')))]) : _vm._e()], 1) : _vm._e(), _vm.originatorDevices.length ? _c(VTab, {
    staticClass: "text-caption",
    attrs: {
      "href": "#add-originator-devices"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-cloud-upload")]), !_vm.isMobile ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.addOriginatorDevices')))]) : _vm._e()], 1) : _vm._e(), _c(VTab, {
    staticClass: "text-caption",
    attrs: {
      "href": "#search-devices"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-search")]), !_vm.isMobile ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.searchDevices')))]) : _vm._e()], 1), _c(VTabsItems, {
    staticClass: "mt-4",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "add-new-device",
    attrs: {
      "value": "add-new-device"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [!_vm.loading ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addNewItem();
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.createNewDevice')) + "\n                      ")]) : _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      "type": "heading"
    }
  })], 1)], 1), _vm.loading ? _c(VRow, {
    staticClass: "mt-6"
  }, [_c(VCol, [_c(VSkeletonLoader, {
    attrs: {
      "type": "text@2"
    }
  })], 1)], 1) : _vm._e()], 1), _c(VTabItem, {
    key: "add-originator-devices",
    attrs: {
      "value": "add-originator-devices"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": "35"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [!_vm.allSelected ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.search'),
            "prepend-icon": "fa-plus-square"
          },
          on: {
            "click": function ($event) {
              return _vm.selectAllDevices(true);
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.selectAll')) + "\n                      ")]) : _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.search'),
            "prepend-icon": "fa-plus-square"
          },
          on: {
            "click": function ($event) {
              return _vm.selectAllDevices(false);
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.unselectAll')) + "\n                      ")])];
      },
      proxy: true
    }])
  }, [_c(VCardText, {
    staticClass: "mt-0 px-0 py-0"
  }, [_c(VRow, {
    staticClass: "tile-wrapper"
  }, _vm._l(_vm.originatorDevices, function (item, key) {
    return _c(VCol, {
      key: `type_${key}`,
      staticClass: "px-2",
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c(VHover, {
      attrs: {
        "open-delay": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function ({
          hover
        }) {
          return [_c(VCard, {
            staticClass: "pa-3 mx-0",
            style: `height: 150px; cursor: pointer; border: 1px solid ${_vm.borderColor};`,
            attrs: {
              "elevation": hover ? 6 : 2
            },
            on: {
              "click": function ($event) {
                return _vm.selectItem(item, key);
              }
            }
          }, [_c('h4', {
            staticClass: "ma-0 pa-0 text-truncate"
          }, [_vm._v(_vm._s(item.name))]), !_vm.isMobile ? _c(VRow, [_c(VCol, {
            staticClass: "mt-12",
            attrs: {
              "cols": "12",
              "md": "10"
            }
          }, [_c('p', {
            staticClass: "mt-4 text-truncate"
          }, [_vm._v(_vm._s(item.eui))])]), _c(VCol, {
            staticClass: "mt-12",
            attrs: {
              "cols": "12",
              "md": "2"
            }
          }, [_c('p', {
            staticClass: "mt-4 text-right"
          }, [item.selected ? _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "small": ""
            }
          }, [_vm._v("fal fa-plus-square")]) : _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "small": ""
            }
          }, [_vm._v("fal fa-plus-square")])], 1)])], 1) : _c(VRow, [_c(VCol, {
            attrs: {
              "cols": "12"
            }
          }, [_c('p', {
            staticClass: "mt-6 text-truncate"
          }, [_vm._v(_vm._s(item.eui))]), _c('span', {
            staticStyle: {
              "float": "right"
            }
          }, [item.selected ? _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "small": ""
            }
          }, [_vm._v("fal fa-plus-square")]) : _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "small": ""
            }
          }, [_vm._v("fal fa-plus-square")])], 1)])], 1)], 1)];
        }
      }], null, true)
    })], 1);
  }), 1)], 1)], 1)], 1), _c(VTabItem, {
    key: "search-devices",
    attrs: {
      "value": "search-devices"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.search'),
            "prepend-icon": "fa-search",
            "disabled": !_vm.euis ? true : false
          },
          on: {
            "click": _vm.searchDevices
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('Common.search')) + "\n                      ")])];
      },
      proxy: true
    }])
  }, [_c(VCardText, {
    staticClass: "mt-0 px-0 py-0"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [!_vm.loading ? _c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.euis'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "rows": "6"
    },
    model: {
      value: _vm.euis,
      callback: function ($$v) {
        _vm.euis = $$v;
      },
      expression: "euis"
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "text@12"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm.selectedItems.length && _vm.tabItem !== 'add-new-device' ? _c('core-n20Card', {
    staticClass: "dt-card-text-01 ml-3 mr-3"
  }, [_c(VCardText, {
    staticClass: "mt-0 px-0 py-0"
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('niota-classic-devices-lists-originator-devices-list', {
    attrs: {
      "list": _vm.selectedItems,
      "originator": _vm.originator,
      "deviceTypes": _vm.deviceTypes
    },
    on: {
      "update": _vm.updateSelectedList,
      "setDeviceTypeId": _vm.setDeviceTypeId,
      "setOperationalStatus": _vm.setOperationalStatus
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };